import React from 'react';
import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import { SNAPSHOT_TEST } from 'utils/constants';

const useStyles = makeStyles({
  arrow: {
    color: '#333333',
  },
  tooltip: {
    border: '1px solid #333333',
    backgroundColor: '#333333',
    fontSize: 14,
    lineHeight: '18px',
    padding: '6px 8px',
    fontFamily: 'Source Sans Pro',
    fontWeight: 'normal',
    textAlign: 'center',
    maxWidth: '180px',
  },
});

const StyledTooltip = (props: TooltipProps) => {
  const classes = useStyles(props);
  return SNAPSHOT_TEST ? (
    <span />
  ) : (
    <Tooltip arrow classes={classes} {...props} />
  );
};
export default StyledTooltip;
